import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';

import {EVENTS} from '@web-landing/analytics/events';
import {YANDEX_METRIKA_ID} from '@web-landing/analytics/ids';

export const log = {
  footerNetworkClick: (linkName: string) => {
    logTmrEvent(EVENTS.footerNetworkClick, {social_link: linkName});

    if (location.pathname === '/media-kit') {
      logTmrEvent(EVENTS.footerMediaKitNetworkClick, {social_link: linkName});
    }
  },

  footerMediaKitClick: (button_text: string) => {
    logTmrEvent(EVENTS.footerMediaKitClick, {button_text});
  },
};

export const ym_log = {
  mainButtonNetworkYM: (linkName: string) => {
    window.ym(
      YANDEX_METRIKA_ID,
      'reachGoal',
      `main_button_network_${linkName}`,
    );
  },
};
